<form class="notifications-form">
  <div class="store-icons">
    <a href="https://play.google.com/store/?utm_source=site" target="_blank"
      ><img alt="Get it on Google Play" src="/assets/play-store-black.png"
    /></a>
    <a href="https://www.apple.com/app-store" target="_blank"
      ><img alt="Download on the App Store" src="/assets/apple-store-black.svg"
    /></a>
  </div>
  <div class="notification" *ngFor="let item of list">
    <label [for]="item.id">{{ item.name }}:</label>
    <mat-slide-toggle
      [checked]="isSelected(item.id)"
      [name]="item.id"
      (change)="handleSelect(item.id)"
    ></mat-slide-toggle>
  </div>

  <div class="notification">
    <label for="all">All updates:</label>
    <mat-slide-toggle
      [checked]="isAllSelecteds()"
      (change)="handleSelectAll()"
    ></mat-slide-toggle>
  </div>
</form>
